<template>
    <div class="nida">
        <div class="nide-container MainText container">
            <div class="row">
                <div class="col-12">
                    <h1>NIDA Drug Screening Tool</h1>
                </div>
            </div>
            <div class="row">

            </div>
            <div class="row">
                <div class="col-12">
                    <div class="nida-assess" v-show="takeScreener">
                        <div class="col-12">
                            <ul>
                                <li>The NIDA is a quick screen tool that helps identify
                                    risky substance use in adults (those 18 and older).</li>
                                <li>A positive screen does not indicate a substance,
                                    alcohol, or opioid use disorder, but rather identifies an
                                    individual’s risk for problematic use. </li>
                                <li>You can complete this tool in one minute. It is
                                    confidential, and easy to use</li>
                                <li>Once the tool is submitted, you will be shown your results and additional resources</li>
                            </ul>
                        </div>

                        <div class="nida-head">In the past year, how often have you used the following?</div>
                        <div class="nida-q">
                            <div>1. Alcohol (For men, 5 or more drinks a day. For women, 4 or more drinks a day)</div>
                            <label for="nida-alc-never">Never</label><input name="alcohol" type="radio" id="nida-alc-never" value="0" v-model="alcVal">
                            <label for="nida-alc-1">Once or Twice</label><input name="alcohol" type="radio" id="nida-alc-1" value="1" v-model="alcVal">
                            <label for="nida-alc-month">Monthly</label><input name="alcohol" type="radio" id="nida-alc-month" value="2" v-model="alcVal">
                            <label for="nida-alc-week">Weekly</label><input name="alcohol" type="radio" id="nida-alc-week" value="3" v-model="alcVal">
                            <label for="nida-alc-day">Daily or Almost Daily</label><input name="alcohol" type="radio" id="nida-alc-day" value="4" v-model="alcVal">
                        </div>
                        <div class="nida-q">
                            <div>2. Tobacco Products</div>
                            <label for="nida-tob-never">Never</label><input name="tobacco" type="radio" id="nida-tob-never" value="0" v-model="tobVal">
                            <label for="nida-tob-1">Once or Twice</label><input name="tobacco" type="radio" id="nida-tob-1" value="1" v-model="tobVal">
                            <label for="nida-tob-month">Monthly</label><input name="tobacco" type="radio" id="nida-tob-month" value="2" v-model="tobVal">
                            <label for="nida-tob-week">Weekly</label><input name="tobacco" type="radio" id="nida-tob-week" value="3" v-model="tobVal">
                            <label for="nida-tob-day">Daily or Almost Daily</label><input name="tobacco" type="radio" id="nida-tob-day" value="4" v-model="tobVal">
                        </div>
                        <div class="nida-q">
                            <div>3. Prescription Drugs for Non-Medical Reasons</div>
                            <label for="nida-script-never">Never</label><input name="prescription" type="radio" id="nida-script-never" value="0" v-model="scriptVal">
                            <label for="nida-script-1">Once or Twice</label><input name="prescription" type="radio" id="nida-script-1" value="1" v-model="scriptVal">
                            <label for="nida-script-month">Monthly</label><input name="prescription" type="radio" id="nida-script-month" value="2" v-model="scriptVal">
                            <label for="nida-script-week">Weekly</label><input name="prescription" type="radio" id="nida-script-week" value="3" v-model="scriptVal">
                            <label for="nida-script-day">Daily or Almost Daily</label><input name="prescription" type="radio" id="nida-script-day" value="4" v-model="scriptVal">
                        </div>
                        <div class="nida-q">
                            <div>4. Illegal Drugs</div>
                            <label for="nida-ill-never">Never</label><input name="illegal" type="radio" id="nida-ill-never" value="0" v-model="illVal">
                            <label for="nida-ill-1">Once or Twice</label><input name="illegal" type="radio" id="nida-ill-1" value="1" v-model="illVal">
                            <label for="nida-ill-month">Monthly</label><input name="illegal" type="radio" id="nida-ill-month" value="2" v-model="illVal">
                            <label for="nida-ill-week">Weekly</label><input name="illegal" type="radio" id="nida-ill-week" value="3" v-model="illVal">
                            <label for="nida-ill-day">Daily or Almost Daily</label><input name="illegal" type="radio" id="nida-ill-day" value="4" v-model="illVal">
                        </div>
                        <div class="nida-footer">
                            <button type="button" class="btn btn-primary" id="nida-submit" @click="submitScreener()">Submit</button>
                        </div>
                    </div>
                    <div class="nida-results" v-show="resultsView">
                        <strong>Results:</strong>
                        <div id="nida-abstain" v-show="noProblem">
                            Your responses don’t suggest reason for concern at this time.
                            If you would like additional resources for healthy living,
                            stress management, and support please see the links below:
                            <ul>
                                <li><a target="_blank" href="https://www.cdc.gov/healthyliving/index.html#https://www.cdc.gov/healthyliving/index.html">Center for Disease Control Index of Healthy Living Resources</a></li>
                                <li><a target="_blank" href="https://hr.umich.edu/benefits-wellness/health-well-being/mental-emotional-health/learn-more-about-mental-emotional-health/thrive-stress-management-program/stress-management-tools-resources#https://hr.umich.edu/benefits-wellness/health-well-being/">Stress Management Tools</a></li>
                                <li><a target="_blank" href="https://humboldtipa.com/wrd-prs/health-wellness/#https://humboldtipa.com/wrd-prs/health-wellness/">Humboldt IPA Wellness Program</a></li>
                                <li><a target="_blank" href="https://al-anon.org/">Al-Anon</a></li>
                                <li><a target="_blank" href="https://al-anon.org/newcomers/teen-corner-alateen/">Al-Anon Teen</a></li>
                            </ul>
                        </div>
                        <div id="nida-drink" v-show="problemAlc">
                            <strong>This result indicates that you are at risk for developing an alcohol use disorder.</strong>
                            <p>One or more days of heavy drinking (e.g. drinking more than the amounts shown in the previous screen for men or women) places a person at risk of health complications related to drinking. Cutting back your drinking to no more than 2 drinks per day (for men)/1 drink per day (for women) can reduce those health risks. If you want to quit or cut back on your alcohol use, but haven’t been able to on your own, talk to your health care provider, there are treatments, including medicine that can help you. </p>
                            <p>Considering cutting back or reducing your use or manage your risk through harm reduction. This resource might help!</p>
                            <ul>
                                <li><a target="_blank" href="https://www.heretohelp.bc.ca/workbook/you-and-substance-use-harm-reduction-strategies">Harm Reduction for Alcohol Use</a></li>
                            </ul>

                        </div>
                        <div id="nida-tobacco" v-show="problemTob">
                            <strong>Any tobacco use places you at risk for tobacco use disorder.</strong>
                            <p>Reducing your tobacco use can lower those risks, but stopping is even better. Talk to your healthcare provider or call 1-800-NO-BUTTS if you would like help stopping.</p>
                        </div>
                        <div id="nida-drugs" v-show="problemDrug">
                            <strong>This result indicates that you are at risk for prescription drug or illegal drug use disorder.</strong>
                            <p>
                                For more information about risky use, please review the following links:
                            </p>
                            <ul>
                                <li>
                                    <a target="_blank" href="https://www.mayoclinic.org/diseases-conditions/prescription-drug-abuse/symptoms-causes/syc-20376813">Mayo Clinic - Prescription drug abuse</a>
                                </li>
                                <li>
                                    <a target="_blank" href="https://www.mhanational.org/risky-business-prescription-drug-misuse">Risky Business: Prescription Drug Misuse</a>
                                </li>
                            </ul>
                            <p>Considering cutting back or reducing your use or manage your risk through harm reduction. This resource might help!</p>
                            <ul>
                                <li><a target="_blank" href="https://humboldtprevention.org/en/how-to-get-naloxone">Naloxone in Humboldt County</a></li>
                            </ul>
                        </div>
                        <div id="nida-further" v-show="problemActions">
                            Based on your results, you may want to consider the following actions or review the provided resources:
                            <ul>
                                <li>Consider making an appointment with your doctor or health care provider to talk about your use.   They will provide an additional assessment to further understand your use, and if needed, can help provide support in connecting you to treatment.</li>
                                <li>If you have Partnership Health Plan Insurance, you can call the Beacon Health Option lines to be screened and connected to a treatment provider by dialing: 1-855-765-9703</li>
                                <li>You may investigate treatment services <a href="http://resourcehub.nchiin.org/share/?ids=31,667,37,80,761,41,110,84,756,715,721,105,757,125,677,18,763,749,69,55,778,57,90,773,769,129,768,760,79,762,48,71,665,774,738,775,593,764,96,770,134,72,78,765,767,98,759,70,779,29,28,670,23,776,663">here</a> or return to the <a href="/">North Coast Resource Hub home page</a> and search based upon your needs.</li>
                                <li>Remember, addiction is a disease and help and support is available!</li>
                            </ul>
                        </div>
                        <div class="nida-footer">
                            <button type="button" class="btn btn-primary" id="nida-retake" @click="retakeScreener()">Retake Assessment</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <p>
                        The NIDA quick screen tool was developed by the
                        National Institute on Drug Abuse and is shared with
                        permission.  More information on the tool can be
                        found here: <a href="https://archives.drugabuse.gov/nmassist/" target="_blank">archives.drugabuse.gov/nmassist/</a>
                    </p>
                </div>
                <div class="col-12">
                    <p>
                        If you would like to share this tool with someone you care about, you can do so by sharing the url for this page: <a href="http://resourcehub.nchiin.org/nida">http://resourcehub.nchiin.org/nida</a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NIDA",
        data () {
            return {
                alcVal: null,
                tobVal: null,
                scriptVal: null,
                illVal: null,

                takeScreener: true,
                resultsView: false,

                problemAlc: false,
                problemTob: false,
                problemDrug: false,
                noProblem: false,
                problemActions: false
            }
        },
        methods: {
            submitScreener(){
                if(this.alcVal === null || this.tobVal === null || this.scriptVal === null || this.illVal === null){
                    alert("Please make a choice for each question");
                    return;
                }

                if(this.alcVal != 0){
                   this.problemAlc =  true
                   this.problemActions = true
                }
                if(this.tobVal != 0){
                    this.problemTob =  true
                    this.problemActions = true
                }
                if(this.scriptVal != 0 || this.illVal != 0){
                    this.problemDrug =  true
                    this.problemActions = true
                }

                if(!this.problemDrug && !this.problemTob && !this.problemAlc){
                    this.noProblem = true
                }

                this.takeScreener = false
                this.resultsView = true
            },
            retakeScreener(){
                this.alcVal = null
                this.tobVal = null
                this.scriptVal = null
                this.illVal = null

                this.problemAlc = false
                this.problemTob = false
                this.problemDrug = false
                this.noProblem = false
                this.problemActions = false

                this.resultsView = false
                this.takeScreener = true
            }
        }
    }
</script>

<style>
    .nide-container {
        margin: 0 auto;
        width: 90%;
    }
    .nida-head {
        font-size: 1.2em;
    }
    .nide-container > div {
        margin-bottom: 10px;
    }

    .nida-q {
        margin-bottom: 15px;
    }

    .nida-q > label {
        padding-left: 10px;
        padding-right: 2px;
    }

    .nida-q > div {
        margin-bottom: 3px;
        font-weight: bold;
    }

    footer > div {
        display: none!important;
    }
</style>